import React, { ComponentProps } from "react";

export default function LightBulbOutlineIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_3795_655921)">
        <path
          d="M9.5 14H6.5C6.224 14 6 13.776 6 13.5C6 13.224 6.224 13 6.5 13H9.5C9.776 13 10 13.224 10 13.5C10 13.776 9.776 14 9.5 14Z"
          fill="#434343"
        />
        <path
          d="M8 2.30467C7.724 2.30467 7.5 2.08067 7.5 1.80467V0.5C7.5 0.224 7.724 0 8 0C8.276 0 8.5 0.224 8.5 0.5V1.80467C8.5 2.08067 8.276 2.30467 8 2.30467Z"
          fill="#434343"
        />
        <path
          d="M12.3807 4.11927C12.2527 4.11927 12.1247 4.07061 12.0274 3.97261C11.832 3.77727 11.832 3.46061 12.0274 3.26527L12.95 2.34261C13.1454 2.14727 13.462 2.14727 13.6574 2.34261C13.8527 2.53794 13.8527 2.85461 13.6574 3.04994L12.7347 3.97261C12.6367 4.06994 12.5087 4.11927 12.3807 4.11927Z"
          fill="#434343"
        />
        <path
          d="M15.5 8.5H14.1953C13.9193 8.5 13.6953 8.276 13.6953 8C13.6953 7.724 13.9193 7.5 14.1953 7.5H15.5C15.776 7.5 16 7.724 16 8C16 8.276 15.776 8.5 15.5 8.5Z"
          fill="#434343"
        />
        <path
          d="M13.3034 13.8034C13.1754 13.8034 13.0474 13.7547 12.95 13.6567L12.0274 12.734C11.832 12.5387 11.832 12.222 12.0274 12.0267C12.2227 11.8314 12.5394 11.8314 12.7347 12.0267L13.6574 12.9494C13.8527 13.1447 13.8527 13.4614 13.6574 13.6567C13.5594 13.7547 13.4314 13.8034 13.3034 13.8034Z"
          fill="#434343"
        />
        <path
          d="M2.69637 13.8034C2.56837 13.8034 2.44037 13.7547 2.34303 13.6567C2.1477 13.4614 2.1477 13.1447 2.34303 12.9494L3.2657 12.0267C3.46103 11.8314 3.7777 11.8314 3.97303 12.0267C4.16837 12.222 4.16837 12.5387 3.97303 12.734L3.05037 13.6567C2.95237 13.7547 2.82437 13.8034 2.69637 13.8034Z"
          fill="#434343"
        />
        <path
          d="M1.80467 8.5H0.5C0.224 8.5 0 8.276 0 8C0 7.724 0.224 7.5 0.5 7.5H1.80467C2.08067 7.5 2.30467 7.724 2.30467 8C2.30467 8.276 2.08067 8.5 1.80467 8.5Z"
          fill="#434343"
        />
        <path
          d="M3.61903 4.11927C3.49103 4.11927 3.36303 4.07061 3.2657 3.97261L2.34303 3.04994C2.1477 2.85461 2.1477 2.53794 2.34303 2.34261C2.53837 2.14727 2.85503 2.14727 3.05037 2.34261L3.97303 3.26527C4.16837 3.46061 4.16837 3.77727 3.97303 3.97261C3.87437 4.06994 3.74703 4.11927 3.61903 4.11927Z"
          fill="#434343"
        />
        <path
          d="M10.5001 8.33333C10.2241 8.33333 10.0001 8.10933 10.0001 7.83333C10.0001 6.822 9.17808 6 8.16675 6C7.89075 6 7.66675 5.776 7.66675 5.5C7.66675 5.224 7.89075 5 8.16675 5C9.72875 5 11.0001 6.27133 11.0001 7.83333C11.0001 8.10933 10.7761 8.33333 10.5001 8.33333Z"
          fill="#434343"
        />
        <path
          d="M8.83311 16H7.16644C6.60444 16 5.99977 15.5733 5.99977 14.6373V13.4613C5.99977 12.754 5.69844 12.1046 5.19377 11.7246C3.73711 10.628 3.06311 8.82398 3.43444 7.01665C3.79777 5.24598 5.23044 3.80798 6.99911 3.43798C8.40511 3.14265 9.84444 3.48465 10.9418 4.37665C12.0378 5.26732 12.6664 6.58798 12.6664 7.99998C12.6664 9.43865 12.0164 10.774 10.8831 11.6653C10.3218 12.1066 9.99977 12.7213 9.99977 13.3513V14.8333C9.99977 15.4766 9.47644 16 8.83311 16ZM7.99044 4.33465C7.72911 4.33465 7.46577 4.36198 7.20244 4.41665C5.81844 4.70598 4.69777 5.83132 4.41311 7.21732C4.12044 8.64198 4.64977 10.0633 5.79444 10.9253C6.54844 11.4933 6.99911 12.4413 6.99911 13.4613V14.6373C6.99911 14.698 7.00711 15 7.16577 15H8.83244C8.92444 15 8.99911 14.9253 8.99911 14.8333V13.3513C8.99911 12.412 9.46044 11.5113 10.2644 10.8786C11.1558 10.1786 11.6664 9.12932 11.6664 7.99998C11.6664 6.89065 11.1718 5.85265 10.3104 5.15265C9.65177 4.61798 8.83511 4.33465 7.99044 4.33465Z"
          fill="#434343"
        />
      </g>
      <defs>
        <clipPath id="clip0_3795_655921">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
